import type {
  InputMultiSelectOption,
  InputMultiSelectProps,
} from './input-multi-select.types'

export enum InputMultiSelectActions {
  ADD_OPTION = 'ADD_OPTION',
  REMOVE_OPTION = 'REMOVE_OPTION',
  CLEAR_OPTIONS = 'CLEAR_OPTIONS',
}

type InputMultiSelectReducerAction =
  | {
      type: InputMultiSelectActions.ADD_OPTION
      payload: InputMultiSelectOption[]
    }
  | {
      type: InputMultiSelectActions.REMOVE_OPTION
      payload: {
        id: string | number
      }
    }
  | {
      type: InputMultiSelectActions.CLEAR_OPTIONS
    }

export function inputMultiSelectReducer(
  confirmedOptionsSelected: InputMultiSelectProps['options'],
  action: InputMultiSelectReducerAction
): InputMultiSelectProps['options'] {
  switch (action.type) {
    case InputMultiSelectActions.ADD_OPTION:
      return [...confirmedOptionsSelected, ...action.payload]

    case InputMultiSelectActions.REMOVE_OPTION:
      return confirmedOptionsSelected.filter(
        option => option.id !== action.payload.id
      )

    case InputMultiSelectActions.CLEAR_OPTIONS:
      return []
  }
}
